// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"69efc3d9","853":"ead67a85"}[chunkId] + ".chunk.js";
};